/* @jsx h */
import { defineComponent, h, Ref } from "vue";
import { useRoute } from "vue-router";
import { PaymentTerminal, Device } from "@lemmonhq/types";
import paymentTerminalURL from "@app/images/payment_terminals/nexgo-n86.png?url";

export type PaymentTerminalDetailsProps = {
  devices: Ref<Device[]>;
};

export const PaymentTerminalDetails =
  defineComponent<PaymentTerminalDetailsProps>({
    name: "PaymentTerminalDetails",
    props: ["devices"],
    setup(props) {
      const route = useRoute();

      return () => {
        console.log("PaymentTerminalDetails", route, route.params);
        const id = route.params.id;
        if (!id) return <div />;

        const terminal = props.devices.value.find(
          (el) =>
            el.type === "payment_terminal" &&
            el.device.id === parseInt(id as string),
        )?.device as PaymentTerminal;
        if (!terminal) return <div />;
        return (
          <div class="space-y-8 flex-1">
            <div class="flex items-center gap-8 border-b py-4 pl-5 ">
              <div class=" border component rounded p-5">
                <div
                  style={`"background-image: url("${paymentTerminalURL}")`}
                  title="EPSON TM-M30"
                  class="w-24 h-24 bg-no-repeat bg-contain bg-center"
                />
              </div>
              <div>
                <div class="flex items-center gap-4 mb-2">
                  <h2 class="text-2xl text-accent">
                    {terminal?.name} | NextGo N86
                  </h2>
                  <span class="px-3 py-1 bg-green-700 text-accent text-sm rounded-full">
                    Connected
                  </span>
                </div>
                <div class=" flex items-center gap-2">
                  <span class="text-accent">Paired</span>
                  <span class="">•</span>
                  <span>
                    <span class="text-accent">ClientID:</span>{" "}
                    {terminal?.client_id}
                  </span>
                </div>
              </div>
            </div>
            <div class="pl-5 flex flex-col gap-8">
              <div class="flex gap-4">
                <button
                  disabled
                  class="btn btn-primary flex items-center gap-2"
                >
                  <span class="flex justify-start items-center">
                    <span class="material-symbols-outlined mr-1 text-2xl">
                      credit_card
                    </span>
                    Test connection
                  </span>
                </button>
              </div>

              <div class="component rounded-lg p-6">
                <h3 class="text-xl mb-4">About this payment terminal</h3>
                <div class="space-y-3">
                  <a
                    target="_blank"
                    href="https://www.nexgoglobal.com/smart-pos/n86.html?template=pro_canshu"
                    class=" hover:text-accent flex items-center gap-2"
                  >
                    <span class="flex justify-start items-center">
                      <span class="material-symbols-outlined mr-1 text-2xl">
                        open_in_new
                      </span>
                      Learn more
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      };
    },
  });
